import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Release } from '../Models/release';
import { ReleaseService } from '../Services/release.service';
import { TenantService } from '@app/Services/tenant.service';
import { MatDialog } from '@angular/material/dialog';
import { PopupDialog } from '@app/Common/popup/popup.dialog';
import { ToastService, ToastButtons, ToastMessageType } from '@app/Common/toast';
import { AsyncPipe, DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { SpinnerComponent } from '../../../../Common/spinner/spinner.component';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslationPipe } from '../../../../Services/translation.pipe';

@Component({
    selector: 'my-release',
    templateUrl: './release.component.html',
    styleUrls: ['./release.component.css'],
    imports: [RouterLink, MatIcon, SpinnerComponent, MatButton, MatProgressSpinner, AsyncPipe, DatePipe, TranslationPipe]
})
export class ReleaseComponent implements OnInit {
    loading: boolean = true;
    release: Release;
    releases: Release[] = [];
    hasReleases = false;
    showReleaseContent = false;
    isPublishLoading = false;

    requestedReleaseNumber = 0;

    constructor(
        private activatedRoute: ActivatedRoute,
        private releaseService: ReleaseService,
        private tenantService: TenantService,
        private router: Router,
        public dialog: MatDialog,
        private toast: ToastService) {
        this.requestedReleaseNumber = this.activatedRoute.snapshot.params.releaseNumber;
    }

    ngOnInit(): void {
        if (this.requestedReleaseNumber > 0) {
            this.showReleaseContent = true;
        }

        if (this.showReleaseContent) {
            this.getRelease();
        } else {
            this.getReleases();
        }
    }

    getRelease(): void {
        this.loading = true;
        this.releaseService.getRelease(this.tenantService.selectedTenant, this.requestedReleaseNumber)
            .then((release: Release) => {
                this.release = release;
                this.hasReleases = true;
                this.loading = false;
            });
    }

    getReleases(): void {
        this.loading = true;
        this.releaseService.getReleases(this.tenantService.selectedTenant)
            .then((releases: Release[]) => {
                this.releases = releases.sort((a, b) => <any>new Date(b.ReleaseDate) - <any>new Date(a.ReleaseDate));
                this.hasReleases = this.releases.length > 0;
                this.loading = false;
            });
    }

    publish(releaseNumber: number) {
        if (this.isPublishLoading) {
            return;
        }
        const dialogRef = this.dialog.open(PopupDialog);
        dialogRef.componentInstance.DialogTitle = 'Publishing Release ';
        dialogRef.componentInstance.DialogDescription = `Are you sure you want to publish version '${releaseNumber}'?`;
        dialogRef.componentInstance.DialogConfirmButtonText = 'Yes';
        dialogRef.componentInstance.DialogCancelButtonText = 'No';

        dialogRef.afterClosed().subscribe(result => {
            if (!result?.Result) {
                return;
            }
            this.releaseService.getRelease(this.tenantService.selectedTenant, releaseNumber).then((release: Release) => {
                if (release.IsPublishAllowed) {
                    this.sendPublishRequest(releaseNumber);
                } else {
                    this.toast.sendMessage('Cannot Release',
                        'This release is now out of sync',
                        ToastMessageType.warning,
                        ToastButtons.None,
                        0);
                }
            });

        });
    }

    private sendPublishRequest(releaseNumber: number): void {
        this.isPublishLoading = true;
        this.releaseService.publish(this.tenantService.selectedTenant, releaseNumber).then(() => {
            this.isPublishLoading = false;
            this.router.navigate(['../'], { relativeTo: this.activatedRoute });
        });
    }
}
